<!-- eslint-disable indent -->
<template>
  <div id="combined-review">
    <a-progress :percent="percentageCompleted" />
    <a-steps
      :current="current"
      style="margin-bottom: 10px; margin-top: 10px"
      size="small"
    >
      <a-step
        v-for="(item, itemIndex) in steps"
        :key="item.title"
        :title="item.title"
        @click="handleStepClick(parseInt(itemIndex))"
        :status="checkStepStatus(item, itemIndex)"
      />
    </a-steps>
    <a-divider v-if="steps[current]">{{ steps[current].subTitle }}</a-divider>
    <a-collapse
      defaultActiveKey="0"
      accordion
      :bordered="true"
      v-if="combinedReviewObj.report_details !== undefined && steps[current]"
    >
      <a-collapse-panel
        :header="tab.heading"
        :key="tabIndex + '_' + current"
        :forceRender="false"
        v-for="(tab, tabIndex) in steps[current].content"
        :class="
          hasUnAnsweredTabs(tabIndex + 1, current + 1)
            ? 'has-unanswered'
            : 'all-answered-collapse'
        "
      >
        <a-list :dataSource="tab.questions">
          <a-list-item
            slot="renderItem"
            slot-scope="item, questionIndex"
            :key="questionIndex + '_' + tabIndex + '_' + current"
          >
            <a-list-item-meta>
              <h3 slot="title">
                <span>
                  <a-icon
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                    v-if="
                      getCombinedResult(current + 1, tabIndex + 1, questionIndex + 1)
                        .length > 0
                    "
                  />
                  <a-icon
                    type="close-circle"
                    theme="twoTone"
                    twoToneColor="#e23d3d"
                    v-else
                  />
                </span>
                {{ current + 1 + "." + (tabIndex + 1) + "." + (questionIndex + 1) + "." }}
                {{ item.question }}
              </h3>
              <div slot="description">
                <div class="individual-answers">
                  <div class="previous-answers" style="margin: 16px 0">
                    <span
                      class="admin-answer choosen-answers"
                      v-if="
                        adminAssessmentData[
                          `question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`
                        ]
                      "
                    >
                      {{
                        isReassessment ? "Original Admin Reviewer:" : "Admin Reviewer:"
                      }}
                      <a-tag color="#87d068" style="text-transform: capitalize">{{
                        adminAssessmentData[
                          `question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`
                        ] | replaceUnderscore
                      }}</a-tag>
                    </span>
                    <span
                      class="first-reviewer-answer choosen-answers"
                      v-if="
                        firstAssessmentData[
                          `question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`
                        ]
                      "
                    >
                      First Reviewer:
                      <a-tag color="#87d068" style="text-transform: capitalize">{{
                        firstAssessmentData[
                          `question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`
                        ] | replaceUnderscore
                      }}</a-tag>
                    </span>
                    <span
                      class="second-reviewer-answer choosen-answers"
                      v-if="
                        secondAssessmmentData[
                          `question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`
                        ]
                      "
                    >
                      Second Reviewer:
                      <a-tag color="#87d068" style="text-transform: capitalize">{{
                        secondAssessmmentData[
                          `question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`
                        ] | replaceUnderscore
                      }}</a-tag>
                    </span>
                  </div>
                  <span style="margin-right: 15px" v-if="!item.adminOnly">
                    {{ isReassessment ? "Reassessment Review:" : "Combined Review:" }}
                  </span>
                  <span style="margin-right: 15px" v-else>
                    {{ isReassessment ? "Admin Reassessment:" : "" }}
                  </span>
                  <a-radio-group
                    :defaultValue="
                      getCombinedResult(current + 1, tabIndex + 1, questionIndex + 1)
                    "
                    :name="`question_${current + 1}_${tabIndex + 1}_${questionIndex + 1}`"
                    buttonStyle="solid"
                    @change="handleQuestionChecked"
                    v-if="
                      !item.adminOnly ||
                      (item.adminOnly &&
                        (userRole === 'telas_telas_administrator' ||
                          userRole === 'telas_admin_reviewers'))
                    "
                  >
                    <a-radio-button
                      :class="item.adminOnly ? 'admin-answer' : ''"
                      value="yes"
                      :disabled="!canAnswer(item) || assessmentStatus === 'complete'"
                    >
                      Yes
                    </a-radio-button>
                    <a-radio-button
                      :class="item.adminOnly ? 'admin-answer' : ''"
                      value="yes_but"
                      :disabled="!canAnswer(item) || assessmentStatus === 'complete'"
                    >
                      Yes But
                    </a-radio-button>
                    <a-radio-button
                      :class="item.adminOnly ? 'admin-answer' : ''"
                      value="no_but"
                      :disabled="!canAnswer(item) || assessmentStatus === 'complete'"
                    >
                      No But
                    </a-radio-button>
                    <a-radio-button
                      :class="item.adminOnly ? 'admin-answer' : ''"
                      value="no"
                      :disabled="!canAnswer(item) || assessmentStatus === 'complete'"
                    >
                      No
                    </a-radio-button>
                    <a-radio-button
                      :class="item.adminOnly ? 'admin-answer unmark' : 'unmark'"
                      value="unmark"
                      :disabled="!canAnswer(item) || assessmentStatus === 'complete'"
                      v-if="
                        userID === combinedReviewObj.report_details.first_reviewer_id ||
                        userRole === 'telas_telas_administrator'
                      "
                    >
                      Unmark
                    </a-radio-button>
                  </a-radio-group>
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <a-divider />
        <div class="domain-assessment" style="text-align: center">
          <span>
            <a-icon
              type="check-circle"
              theme="twoTone"
              twoToneColor="#52c41a"
              v-if="getDefaultDomainScore(current + 1, tabIndex + 1).length > 0"
            />
            <a-icon type="close-circle" theme="twoTone" twoToneColor="#e23d3d" v-else />
          </span>
          {{ isReassessment ? "Reassessment Overall:" : "Overall:" }}
          <a-radio-group
            slot="description"
            :defaultValue="getDefaultDomainScore(current + 1, tabIndex + 1)"
            buttonStyle="solid"
            size="small"
            :name="getDomainRadioName(current + 1, tabIndex + 1)"
            @change="handleDomainValueChange"
          >
            <a-radio-button
              :value="domainScoreValue.key"
              v-for="(domainScoreValue, domainScoreKey) in sortDomainScore(
                tab.domainScore
              )"
              :key="domainScoreKey"
              :disabled="
                canAnswerDomain(tab.questions) ||
                userID === combinedReviewObj.report_details.second_reviewer_id ||
                assessmentStatus === 'complete'
              "
              :class="canAnswerDomain(tab.questions) ? 'admin-answer' : ''"
            >
              {{ domainScoreValue.value }}
            </a-radio-button>
          </a-radio-group>
        </div>
      </a-collapse-panel>
    </a-collapse>
    <!-- {{steps}} -->
    <div class="steps-action" style="margin-top: 10px">
      <a-button v-if="current > 0" style="float: left" @click="prev"> Previous </a-button>
      <a-button
        v-if="current < Object.keys(steps).length - 1"
        type="primary"
        @click="next"
        style="float: right"
      >
        Next
      </a-button>
    </div>
    <div
      class="comment"
      :style="{ marginTop: '20px', clear: 'both', paddingTop: '10px' }"
      v-if="isReassessment"
    >
      <h3>Reassessment Comments</h3>
      <label style="margin-top: 16px; display: block">
        Admin Reassessment Comments:
        <a-textarea
          :style="{ marginTop: '10px' }"
          placeholder=""
          autoSize
          v-model="adminReassessmentComments[`standard_${current}_comment`]"
          v-if="
            (this.userID === this.combinedReviewObj.report_details.admin_reviewer_id ||
              userRole === 'telas_telas_administrator') &&
            assessmentStatus !== 'complete' &&
            assessmentStatus !== 'completed'
          "
        />
        <a-alert
          type="info"
          style="margin-bottom: 5px"
          v-if="
            assessmentStatus === 'complete' ||
            assessmentStatus === 'completed' ||
            this.userID === this.combinedReviewObj.report_details.first_reviewer_id
          "
        >
          <div
            slot="message"
            v-html="$marked(adminReassessmentComments[`standard_${current}_comment`])"
          ></div>
        </a-alert>
      </label>
      <label
        v-if="userRole !== 'telas_admin_reviewers'"
        style="margin-top: 16px; display: block"
      >
        Reassessment Comments:
        <a-textarea
          :style="{ marginTop: '10px' }"
          placeholder=""
          autoSize
          v-model="reassessmentComments[`standard_${current}_comment`]"
          v-if="
            (this.userID === this.combinedReviewObj.report_details.first_reviewer_id ||
              userRole === 'telas_telas_administrator') &&
            assessmentStatus !== 'complete' &&
            assessmentStatus !== 'completed'
          "
        />
        <a-alert
          type="info"
          style="margin-bottom: 5px"
          v-if="
            reassessmentComments[`standard_${current}_comment`] &&
            (assessmentStatus === 'complete' || assessmentStatus === 'completed')
          "
        >
          <div
            slot="message"
            v-html="$marked(reassessmentComments[`standard_${current}_comment`])"
          ></div>
        </a-alert>
      </label>
    </div>
    <div
      class="comment"
      :style="{ marginTop: '20px', clear: 'both', paddingTop: '10px' }"
    >
      <label
        ><h3>{{ isReassessment ? "Original Comments:" : "Comments:" }}</h3>
        <a-alert
          v-if="adminReviewerComments[`standard_${current}_comment`]"
          type="info"
          style="margin-bottom: 5px"
        >
          <div
            slot="message"
            v-html="
              $marked(
                'Admin Reviewer Comments: <br />' +
                  adminReviewerComments[`standard_${current}_comment`]
              )
            "
          ></div>
        </a-alert>
        <a-alert
          v-if="firstReviewerComments[`standard_${current}_comment`]"
          type="info"
          style="margin-bottom: 5px"
        >
          <div
            slot="message"
            v-html="
              $marked(
                'First Reviewer Comments: <br />' +
                  firstReviewerComments[`standard_${current}_comment`]
              )
            "
          ></div>
        </a-alert>
        <a-alert
          v-if="secondReviewerComments[`standard_${current}_comment`]"
          type="info"
          style="margin-bottom: 5px"
        >
          <div
            slot="message"
            v-html="
              $marked(
                'Second Reviewer Comments: <br />' +
                  secondReviewerComments[`standard_${current}_comment`]
              )
            "
          ></div>
        </a-alert>
        <label
          v-if="
            (this.userID === this.combinedReviewObj.report_details.first_reviewer_id ||
              userRole === 'telas_telas_administrator') &&
            assessmentStatus !== 'complete' &&
            assessmentStatus !== 'completed' &&
            !isReassessment
          "
        >
          Combined Review Comments
          <a-textarea
            :style="{ marginTop: '10px' }"
            placeholder=""
            autoSize
            v-model="reviewComments[`standard_${current}_comment`]"
          />
        </label>
        <a-alert v-else type="info" style="margin-bottom: 5px">
          <div
            slot="message"
            v-html="
              $marked(
                'Combined Review Comments: <br />' +
                  reviewComments[`standard_${current}_comment`]
              )
            "
          ></div
        ></a-alert>
      </label>
    </div>
    <a-button-group
      :style="{ marginTop: '20px', textAlign: 'left' }"
      v-if="percentageCompleted >= 100"
    >
      <a-button
        id="download-pdf"
        type="dashed"
        icon="download"
        :loading="isDownloading"
        @click="handleDownloadPDF"
        v-if="assessmentStatus === 'complete' || assessmentStatus === 'completed'"
      >
        Download PDF
      </a-button>
      <a href="test" ref="testButton" download v-show="false">Test Button</a>
    </a-button-group>
    <a-button-group
      class="button-group"
      :style="{ width: '100%', marginTop: '20px', textAlign: 'right' }"
    >
      <a-popconfirm
        placement="topLeft"
        ok-text="Yes"
        cancel-text="No"
        @confirm="markPending()"
      >
        <template slot="title">
          <p>Refer assessment to admin</p>
        </template>
        <a-button
          id="pending-button"
          type="default"
          icon="exclamation-circle"
          :disabled="
            assessmentStatus === 'complete' ||
            (userID !== combinedReviewObj.report_details.first_reviewer_id &&
              userRole !== 'telas_telas_administrator') ||
            assessmentStatus === 'completed'
          "
        >
          Mark Pending
        </a-button>
      </a-popconfirm>
      <a-button
        id="save-button"
        type="default"
        icon="cloud-download"
        @click="saveAssessments('in-progress')"
        v-if="!isReassessment"
        :disabled="
          assessmentStatus === 'complete' ||
          (userID !== combinedReviewObj.report_details.first_reviewer_id &&
            userRole !== 'telas_telas_administrator') ||
          assessmentStatus === 'completed'
        "
      >
        Save Combined Review
      </a-button>
      <a-button
        id="save-reassessment-button"
        type="default"
        icon="cloud-download"
        v-else
        :disabled="
          assessmentStatus === 'complete' ||
          (userID !== combinedReviewObj.report_details.first_reviewer_id &&
            userRole !== 'telas_telas_administrator' &&
            userRole !== 'telas_admin_reviewers') ||
          assessmentStatus === 'completed'
        "
        @click="saveAssessments('in-progress')"
      >
        Save Reassessment
      </a-button>
      <a-popconfirm
        placement="top"
        ok-text="I'm sure"
        cancel-text="Keep editing"
        @confirm="saveAssessments('complete')"
        :disabled="percentageCompleted < 100"
        okType="danger"
      >
        <template slot="title">
          <h3>Are you Sure?</h3>
          <p>
            If you click 'Yes', you will not be able to make any more changes to this
            assessment.
          </p>
        </template>
        <a-button
          id="mark-complete-button"
          type="default"
          icon="check-circle"
          :disabled="percentageCompleted < 100"
          v-if="
            assessmentStatus !== 'complete' &&
            assessmentStatus !== 'completed' &&
            (userRole === 'telas_telas_administrator' ||
              userID === combinedReviewObj.report_details.first_reviewer_id)
          "
        >
          Mark Complete
        </a-button>
      </a-popconfirm>
      <a-popconfirm
        placement="topLeft"
        ok-text="Yes"
        cancel-text="No"
        @confirm="saveAssessments('in-progress')"
      >
        <template slot="title">
          <p>Are you sure you want to <b>unmark</b> this assessment as complete?</p>
        </template>
        <a-button
          id="unmark-complete-button"
          type="danger"
          ghost
          v-if="
            (assessmentStatus === 'complete' || assessmentStatus === 'completed') &&
            userRole === 'telas_telas_administrator'
          "
        >
          Unmark Complete
        </a-button>
      </a-popconfirm>
    </a-button-group>
  </div>
</template>

<script>
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  name: "combined-review",
  data() {
    return {
      steps: [],
      combinedReviewAnswers: {},
      current: 0,
      isEditable: true,
      detailedReportData: {},
      firstReviewerAnswers: {},
      adminReviewerData: {},
      reviewComments: {},
      adminReassessmentComments: {},
      reassessmentComments: {},
      domainScore: [],
      percentageCompleted: 0,
      isDownloading: false,
      combinedResults: {},
      combinedResultsLength: 0,
      isReassessment: false,
    };
  },
  components: {},
  props: [
    "combinedReviewObj",
    "oriFirstReviewerAnswerData",
    "assessmentStatus",
    "reassessment",
    "firstReviewerId",
    "comments",
    "admin_reassessment_comments",
    "reassessment_comments",
    "adminAssessmentData",
    "firstAssessmentData",
    "secondAssessmmentData",
    "adminReviewerComments",
    "firstReviewerComments",
    "secondReviewerComments",
  ],
  computed: {
    ...mapGetters("user", {
      userToken: "getUserToken",
      userRole: "getUserRole",
      userID: "getUserId",
    }),
    ...mapState("assessments", {
      questions: (state) => state.assessmentQuestions,
      pdfLink: (state) => state.pdfLink,
    }),
    ...mapState("frameworks", {
      questions: (state) => state.frameworkQuestions,
    }),
    console: () => console,
    window: () => window,
  },
  beforeMount() {},
  created() {
    this.refetchData();
    this.reviewComments = this.comments;
    this.adminReassessmentComments = this.admin_reassessment_comments;
    this.reassessmentComments = this.reassessment_comments;
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === "frameworks/SET_FRAMEWORK_QUESTIONS") {
        this.steps = this.questions;
        console.log(this.steps);
        this.getProgress();
        this.updateProgress();
        this.hasUnFilledStep();
      }
    });
    this.combinedResults = this.getAllCombinedResults();
    this.combinedResultsLength = Object.keys(this.combinedResults).length;
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.console.log(this.combinedReviewObj.report_details);
    this.courseId = this.combinedReviewObj.report_details.course_id;
    this.console.log(this.courseId);
    this.fetchFrameworkId();
    this.isReassessment = this.combinedReviewObj.report_details.reassessment[0]; // Check if the report is a reassessment
    console.log(this.isReassessment);
  },
  watch: {},
  methods: {
    async fetchFrameworkId() {
      if (!this.courseId || !this.userToken) {
        console.error("Course ID or user token is missing");
        return;
      }
      try {
        const frameworkId = await this.getCourseFramework({
          courseId: this.courseId,
          userToken: this.userToken,
        });
        console.log("Framework ID", frameworkId);
        // Now you have the frameworkId, you can directly call fetchFrameworkQuestions
        // Or store it in your component's state and use it wherever needed
        this.fetchFrameworkQuestions(frameworkId);
      } catch (error) {
        console.error("Failed to fetch framework ID", error);
      }
    },
    async refetchData() {
      await this.fetchFrameworkQuestions(this.frameworkId);
    },
    getTotalQuestionsCount() {
      // Clone this.steps to use a non-Observer node
      const clonedSteps = Object.values(JSON.parse(JSON.stringify(this.steps)));
      let totalQuestionCount = 0;
      clonedSteps.forEach((step) => {
        step.content.forEach((content) => {
          const contentQuestionsLength = content.questions.length;
          // Add 1 to score to account for the domainScore question
          totalQuestionCount += contentQuestionsLength + 1;
        });
      });
      return totalQuestionCount;
    },
    getCombinedResult(stepIndex, contentIndex, questionIndex) {
      let reviewerReviewData = {};
      if (this.userID === this.combinedReviewObj.report_details.first_reviewer_id) {
        reviewerReviewData = this.combinedReviewObj.report_details
          .first_reviewer_assessment_data.review_data;
      } else if (
        this.userID === this.combinedReviewObj.report_details.second_reviewer_id
      ) {
        reviewerReviewData = this.combinedReviewObj.report_details
          .second_reviewer_assessment_data.review_data;
      } else if (
        this.userRole === "telas_telas_administrator" ||
        (this.userRole === "telas_admin_reviewers" && this.isReassessment === "true")
      ) {
        reviewerReviewData = this.combinedReviewObj.report_details
          .first_reviewer_assessment_data.review_data;
      } else {
        reviewerReviewData = {};
      }
      const combinedReviewData = {
        ...this.combinedReviewObj.report_details.admin_reviewer_assessment_data
          .review_data,
        ...reviewerReviewData,
        ...this.combinedReviewAnswers,
      };
      return combinedReviewData[`question_${stepIndex}_${contentIndex}_${questionIndex}`]
        ? combinedReviewData[`question_${stepIndex}_${contentIndex}_${questionIndex}`]
        : "";
    },
    getAllCombinedResults() {
      let reviewerReviewData = [];
      const first_reviewer =
        this.userID === this.combinedReviewObj.report_details.first_reviewer_id;
      const second_reviewer =
        this.userID === this.combinedReviewObj.report_details.second_reviewer_id;
      const telas_admin = this.userRole === "telas_telas_administrator";
      if (first_reviewer) {
        reviewerReviewData = this.combinedReviewObj.report_details
          .first_reviewer_assessment_data.review_data;
      } else if (second_reviewer) {
        reviewerReviewData = this.combinedReviewObj.report_details
          .second_reviewer_assessment_data.review_data;
      } else if (telas_admin) {
        reviewerReviewData = this.combinedReviewObj.report_details
          .first_reviewer_assessment_data.review_data;
      } else {
        reviewerReviewData = {};
      }
      const allCombinedReviewData = {
        ...this.combinedReviewObj.report_details.admin_reviewer_assessment_data
          .review_data,
        ...reviewerReviewData,
        ...this.combinedReviewAnswers,
      };
      return allCombinedReviewData;
    },
    handleQuestionChecked(e) {
      const questionKey = e.target.name;
      const { value } = e.target;
      this.firstReviewerAnswers[questionKey] = value;
      this.firstReviewerAnswers = {
        ...this.oriFirstReviewerAnswerData,
        ...this.firstReviewerAnswers,
      };
      if (!value) {
        delete this.oriFirstReviewerAnswerData[questionKey];
        delete this.firstReviewerAnswers[questionKey];
      }
      const questionAnswer = {
        id: questionKey,
        value: value,
      };
      this.updateProgress(questionAnswer);
    },
    canAnswer(itemObj) {
      this.admin_reassessment_status = this.combinedReviewObj.report_details.admin_reassessment_status;

      if (this.userRole === "telas_telas_administrator") {
        return true; // Always return true for telas_telas_administrator
      }

      if (this.isReassessment === "true") {
        if (this.assessmentStatus === "completed") {
          return false;
        }
        if (
          this.admin_reassessment_status === "completed" &&
          this.userID !== this.combinedReviewObj.report_details.first_reviewer_id
        ) {
          return false;
        }
        if (
          itemObj.adminOnly &&
          (this.userRole === "telas_telas_administrator" ||
            this.userRole === "telas_admin_reviewers")
        ) {
          return true;
        }
        if (!itemObj.adminOnly && this.userRole === "telas_admin_reviewers") {
          return false; // Return false for telas_admin_reviewers if itemObj.adminOnly is false
        }
        if (this.isEditable) {
          return true;
        }
        if (this.isEditable && this.assessmentStatus === "completed") {
          return true;
        }
        if (this.userID === this.combinedReviewObj.report_details.first_reviewer_id) {
          return true;
        }
      } else {
        if (this.assessmentStatus === "completed") {
          return false;
        }
        if (
          itemObj.adminOnly &&
          (this.userRole === "telas_telas_administrator" ||
            this.userRole === "telas_admin_reviewers")
        ) {
          return true;
        }
        if (
          itemObj.adminOnly ||
          this.userID === this.combinedReviewObj.report_details.second_reviewer_id
        ) {
          return false;
        }
        if (
          itemObj.adminOnly ||
          this.userID === this.combinedReviewObj.report_details.admin_reviewer_id
        ) {
          return false;
        }
        if (
          (this.userRole === "telas_telas_administrator" ||
            this.userRole === "telas_admin_reviewers") &&
          this.assessmentStatus !== "completed"
        ) {
          return true;
        }
        if (this.isEditable) {
          return true;
        }
        if (this.isEditable && this.assessmentStatus === "completed") {
          return true;
        }
        if (this.userID === this.combinedReviewObj.report_details.first_reviewer_id) {
          return true;
        }
        return true;
      }
    },

    next() {
      // eslint-disable-next-line
      this.current++;
    },
    prev() {
      // eslint-disable-next-line
      this.current--;
    },
    handleStepClick(step) {
      this.current = parseInt(step, 16);
    },

    saveAssessments(status) {
      const firstReviewerAnswerData = {
        ...this.oriFirstReviewerAnswerData,
        ...this.firstReviewerAnswers,
      };
      const combinedReviewArgs = {
        reportId: this.$route.params.reportId,
        firstReviewerAnswers: firstReviewerAnswerData,
        assessmentStatus: status,
        comments: this.reviewComments,
        admin_reassessment_comments: this.adminReassessmentComments,
        reassessment_comments: this.reassessmentComments,
        pending: "no",
        userToken: this.userToken,
      };
      this.updateReport(combinedReviewArgs);
      this.updateProgress();
    },
    markPending() {
      const firstReviewerAnswerData = {
        ...this.oriFirstReviewerAnswerData,
        ...this.firstReviewerAnswers,
      };
      const combinedReviewArgs = {
        reportId: this.$route.params.reportId,
        firstReviewerAnswers: firstReviewerAnswerData,
        assessmentStatus: "in-progress",
        comments: this.reviewComments,
        admin_reassessment_comments: this.adminReassessmentComments,
        reassessment_comments: this.reassessmentComments,
        pending: "yes",
        userToken: this.userToken,
      };
      this.updateReport(combinedReviewArgs);
    },
    ...mapActions("assessments", {
      updateReport: "updateReport",
      //getAssessmentQuestions: "getAssessmentQuestions",
      getCombinedReports: "getCombinedReports",
      downloadPDF: "downloadPDF",
    }),
    ...mapActions("courses", {
      getCourseDetails: "getCourseDetails",
      getCourseFramework: "getCourseFramework",
    }),
    ...mapActions("frameworks", {
      fetchFrameworkQuestions: "fetchFrameworkQuestions",
    }),
    ...mapMutations("frameworks", {
      setFrameworkQuestions: "SET_FRAMEWORK_QUESTIONS",
    }),
    ...mapMutations("courses", {
      setCourseDetails: "SETCOURSEDETAIL",
      setCourseFramework: "SETCOURSEFRAMEWORK",
    }),
    getDefaultDomainScore(stepIndex, tabIndex) {
      const domain = this.getDomain(stepIndex);
      if (
        this.firstReviewerAnswers[`domain_${domain}_${stepIndex}_${tabIndex}`] ===
        undefined
      ) {
        return this.oriFirstReviewerAnswerData[
          `domain_${domain}_${stepIndex}_${tabIndex}`
        ] === undefined
          ? ""
          : this.oriFirstReviewerAnswerData[`domain_${domain}_${stepIndex}_${tabIndex}`];
      }
      return this.firstReviewerAnswers[`domain_${domain}_${stepIndex}_${tabIndex}`];
    },
    getDomain(step) {
      let domain = 1;
      if (step >= 1 && step <= 2) {
        domain = 1;
        // console.log(domain);
      } else if (step > 2 && step <= 4) {
        domain = 2;
        // console.log(domain);
      } else if (step >= 5 && step <= 6) {
        domain = 3;
        // console.log(domain);
      } else if (step >= 7 && step <= 8) {
        domain = 4;
        // console.log(domain);
      }
      return domain;
    },
    getDomainRadioName(step, tabIndex) {
      const domainIndex = this.getDomain(step);
      return `domain_${domainIndex}_${step}_${tabIndex}`;
    },
    handleDomainValueChange(e) {
      const questionKey = e.target.name;
      const { value } = e.target;
      this.firstReviewerAnswers[questionKey] = value;
      this.firstReviewerAnswers = {
        ...this.oriFirstReviewerAnswerData,
        ...this.firstReviewerAnswers,
      };
      if (!this.domainScore.includes(questionKey)) {
        this.domainScore.push(questionKey);
        this.getProgress();
        this.hasUnFilledStep();
      }
      const questionAnswer = {
        id: questionKey,
        value: value,
      };
      this.updateProgress(questionAnswer);
    },
    canAnswerDomain(questionsObj) {
      if (!this.isEditable) {
        return true;
      }
      if (this.isEditable && this.assessmentStatus === "completed") {
        return true;
      }
      if (this.userID === this.combinedReviewObj.report_details.admin_reviewer_id) {
        return true;
      }
      if (
        (this.userRole === "telas_telas_administrator" ||
          this.userRole === "telas_admin_reviewers") &&
        this.assessmentStatus !== "completed"
      ) {
        return false;
      }
      if (this.userID === this.firstReviewerId) {
        return false;
      }
      const hasNonAdminQuestion = questionsObj.some((item) => !item.adminOnly);
      const hasAdminOnlyQuestion = questionsObj.some((item) => item.adminOnly);

      if (
        this.userRole === "telas_admin_reviewers" ||
        this.userRole === "telas_telas_administrator"
      ) {
        return !hasAdminOnlyQuestion;
      }
      return !hasNonAdminQuestion;
    },
    hasConflict(tabIndex, stepIndex) {
      const { questions } = this.steps[stepIndex].content[tabIndex];
      const hasConflict = Object.keys(questions)
        .map((questionKey) =>
          this.getCombinedResult(
            stepIndex + 1,
            tabIndex + 1,
            parseInt(questionKey, 10) + 1
          )
        )
        .some((answerValue) => answerValue.length <= 0);
      return hasConflict;
    },
    checkStepStatus(itemObj, index) {
      let stepStatus = "process";
      if (this.current.toString() === index) {
        stepStatus = "process";
      } else if (itemObj.allAnswered) {
        stepStatus = "finish";
      } else {
        stepStatus = "error";
      }
      return stepStatus;
    },
    hasUnFilledStep() {
      for (let stepIndex = 0; stepIndex < Object.keys(this.steps).length; stepIndex++) {
        for (
          let tabIndex = 0;
          tabIndex < this.steps[stepIndex].content.length;
          tabIndex++
        ) {
          if (this.getDefaultDomainScore(stepIndex + 1, tabIndex + 1).length <= 0) {
            this.steps[stepIndex].allAnswered = false;
          } else {
            this.steps[stepIndex].allAnswered = true;
          }
        }
      }
    },
    hasUnAnsweredTabs(tabIndex, stepIndex) {
      if (this.getDefaultDomainScore(stepIndex, tabIndex).length <= 0) {
        return true;
      }
      return false;
    },
    sortDomainScore(domainScoreValue) {
      const order = ["Yes", "Yes But", "No But", "No"];
      const newOrder = [];
      Object.entries(domainScoreValue).map((a) => {
        newOrder.push({
          key: a[0],
          value: a[1],
        });
        return "";
      });
      newOrder.sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value));
      return newOrder;
    },
    logUnwrappedSteps() {
      return JSON.parse(JSON.stringify(this.steps));
    },
    getProgress() {
      let totalDomains = 0;
      const originalDomainScores = [];
      for (let stepIndex = 0; stepIndex < Object.keys(this.steps).length; stepIndex++) {
        const domain = this.getDomain(stepIndex + 1);
        for (
          let tabIndex = 0;
          tabIndex <= this.steps[stepIndex].content.length;
          tabIndex++
        ) {
          if (
            this.oriFirstReviewerAnswerData[
              `domain_${domain}_${stepIndex + 1}_${tabIndex + 1}`
            ] !== undefined
          ) {
            originalDomainScores.push(
              this.oriFirstReviewerAnswerData[
                `domain_${domain}_${stepIndex + 1}_${tabIndex + 1}`
              ]
            );
            // originalDomainScores.push(this.adminAssessmentData[`domain_${domain}_${stepIndex + 1}_${tabIndex + 1}`]);
          }
        }
        totalDomains += this.steps[stepIndex].content.length;
      }
    },
    updateProgress(answer) {
      if (answer) {
        this.combinedResults[answer.id] = answer.value;
      }

      const allCombinedResultsLength = Object.values(this.combinedResults).length;

      const totalQuestionCount = this.getTotalQuestionsCount();

      this.percentageCompleted = Math.floor(
        (allCombinedResultsLength / totalQuestionCount) * 100
      );
    },
    handleDownloadPDF() {
      this.isDownloading = true;
      this.downloadPDF({
        assessmentId: this.$route.params.reportId,
        userToken: this.userToken,
        isReport: "yes",
      }).then(() => {
        this.isDownloading = false;
        const dummyButton = this.$refs.testButton;
        dummyButton.href = this.pdfLink.fileURL;
        dummyButton.target = "_blank";
        dummyButton.click();
      });
    },
  },
};
</script>

<style>
.has-unanswered .ant-collapse-header {
  color: red !important;
  text-decoration: underline #198ffc;
}

.ant-steps-item-icon {
  width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  font-size: 12px !important;
  vertical-align: middle !important;
}

.ant-steps-item-title {
  font-size: 12px !important;
}

.ant-steps-item-content {
  vertical-align: middle !important;
}

.ant-steps-item:hover {
  cursor: pointer;
}
</style>
<style scoped>
#mark-complete-button:hover {
  border-color: #73d13d;
  background-color: #73d13d;
  color: #ffff;
}

#mark-complete-button {
  color: #73d13d;
}

#save-button:hover {
  border-color: #40a9ff;
  background-color: #40a9ff;
  color: #ffff;
}

.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  background-color: #52c41a !important;
  color: #fff;
  border: gray;
  box-shadow: 0px -1px 4px 1px #c5baba;
  border-radius: 1px;
}

.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked.admin-answer {
  background-color: #3d4a4a !important;
}

label.ant-radio-button-wrapper.unmark {
  color: gray;
}

label.ant-radio-button-wrapper.unmark:hover {
  color: white;
  background: orange;
}

label.ant-radio-button-wrapper.ant-radio-button-wrapper-checked.unmark {
  background-color: #ff0000a6;
  color: white;
  border-color: #ff0000a6;
}
</style>
